const reducer = (state, { type, payload }) => {
	// console.log('reducer:', type, payload);
	// console.log('reducer:'+type);
	switch (type) {
		case "IN_LOADING":
			return {
				...state,
				loading: true
			}
		
		case "SET_STATE_DATA":
			return {
				...state,
				...payload,
			}
		case "SET_FILTER_PART":
			return {
				...state,
				filters : {...state.filters, ...payload.part},
			}
			
		case "CLEAR_FILTER":
			return {
				...state,
				filters : {},
        searchResult: undefined,
			}
		
		case "SET_SEARCH_RESULT":
			return {
				...state,
				searchResult:payload.searchResult,
				loading: false
			}
		
        case "SET_NEW_ITEM":
			return {
				...state,
				newItem:state.newItem?{...state.newItem, ...payload}:payload,
			}
            
        case "CLEAR_NEW_ITEM":
			return {
				...state,
				newItem:{},
			}
		
        case "SET_NEW_MODE":
			return {
				...state,
				newMode:payload,
			}
		
		case "CLEAR_SEARCH":
			return {
				...state,
				searchResult:{},
				Constants:payload.Constants,
				bpAccess:payload.bpAccess,
			}
		
		case "LOADED":
			return {
				...state,
				message:undefined,
				loading: false,
			}
		
		
		case "LOAD_FAILED":
			return {
				...state,
				message:payload,
				loading: false,
			}
		
		
		default:
			return state
  }
}

export default reducer;